import React from 'react';

import { Organization, WebSite } from 'ha/components/LinkedData';
import { useIntl } from 'ha/i18n';
import { ContentfulSupportedLangs } from 'ha/modules/Hermes/constants';

import { TopCities as list } from '../constants';
import { Blog } from '../types';
import Hero from './Hero';
import HomeHelmet from './HomeHelmet';
import TopCities from '../containers/TopCities';
import InfoSection from './InfoSection';
import FeaturedCities from '../containers/FeaturedCities';
import { ApartmentsAndRooms } from './FeaturedCities/ApartmentsAndRooms';
import Separator from './Separator';
import BlogCards from './BlogCards';
import { FeaturedCountries } from './FeaturedCountries/FeaturedCountries';

interface Props {
  blogs: Blog[];
}

const HomeLayout: React.FC<Props> = ({ blogs }) => {
  const { lang } = useIntl();

  return (
    <div>
      <HomeHelmet />
      <Organization />
      <WebSite />
      <Hero />
      <TopCities list={list} />
      <Separator rotate />
      <InfoSection />
      <FeaturedCities />
      <Separator />
      {ContentfulSupportedLangs.includes(lang) ? (
        <FeaturedCountries />
      ) : (
        <ApartmentsAndRooms />
      )}
      {blogs.length > 0 && (
        <React.Fragment>
          <Separator rotate />
          <BlogCards blogs={blogs} />
        </React.Fragment>
      )}
    </div>
  );
};

export default HomeLayout;
